import { createAction, props } from '@ngrx/store';
import { PermissionModel } from '../../../models/identity/authentication.model';

export const PERM_SET_PERMISSION = '[PERM][SET]::[Permission]';
export const PERM_RESET_ALL = '[PERM][RESET]::[All]';

export const SetPermission = createAction(
  PERM_SET_PERMISSION,
  props<{ permissions: PermissionModel[] }>()
);
export const ResetAll = createAction(PERM_RESET_ALL);
